import { ConstructorTabs } from "../../../components/admin-console/constructor-tabs";
import { MOCK_CONSTRUCTOR_SERVICES } from "../../constructor-services-page/constructor-services-page.lib";

/** Табы «Конструктор — Услуги / Дороги / Документы» со счётчиком услуг (дороги — константа из макета). */
export const ConstructorDocumentsTabs = () => <ConstructorTabs servicesCount={MOCK_CONSTRUCTOR_SERVICES.length} />;
